import styled from 'styled-components';

export const Container = styled.div``;

export const LbSwitch = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
